import React from 'react';
import { LEGAL_LINKS } from '../utils/legal.ts';

/**
 * Privacy Policy / Terms of Use links for the app's unauthenticated screens.
 *
 * These are the only surfaces in the customer app that need them: everything
 * past sign-in is governed by the customer's Master Service Agreement, and the
 * Terms of Use say so explicitly. The sign-in screen is where a healthcare
 * buyer's security reviewer looks for them, and it is also the point where a
 * person who is not yet inside any contract meets the application.
 *
 * They open in a new tab because they live on a different origin — sending a
 * user mid-authentication away from the login page would lose their progress
 * through the MFA challenge flow.
 */
export const LegalLinks: React.FC = () => (
  <p className="login-legal">
    {LEGAL_LINKS.map((link, i) => (
      <React.Fragment key={link.href}>
        {i > 0 && <span aria-hidden="true"> · </span>}
        <a
          className="login-link"
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.label}
        </a>
      </React.Fragment>
    ))}
  </p>
);

export default LegalLinks;
